import React, { useState } from 'react';
import { findChildByType } from '@fiverr-private/ui_utils';
import { Container } from '@fiverr-private/layout_components';
import type { AlertProps } from './types';
import { ALERT_ACTIONS_ID, ALERT_TEXT_ID, ALERT_TITLE_ID, VARIANTS_CONFIG } from './constants';
import { AlertContext } from './AlertContext';

const Alert = ({ variant, children, ...restProps }: AlertProps) => {
  const [dismissed, setDismissed] = useState(false);
  const alertTitle = findChildByType(children, ALERT_TITLE_ID);
  const alertText = findChildByType(children, ALERT_TEXT_ID);
  const alertActions = findChildByType(children, ALERT_ACTIONS_ID);

  const shouldCenterIcon = !alertTitle && Boolean(alertActions);

  const { Icon, iconColor, color, backgroundColor } = VARIANTS_CONFIG[variant];

  if (dismissed) {
    return null;
  }

  return (
    <AlertContext.Provider value={{ variant, setDismissed }}>
      <Container
        display="flex"
        alignItems={shouldCenterIcon ? { md: 'center' } : undefined}
        padding="4"
        borderRadius="lg"
        color={color}
        backgroundColor={backgroundColor}
        role="alert"
        {...restProps}
      >
        <Container
          as="span"
          display="flex"
          flexShrink={0}
          paddingTop={shouldCenterIcon ? undefined : 'px'}
          marginRight="3"
        >
          <Icon size={20} color={iconColor} />
        </Container>
        <Container
          display="flex"
          flex={1}
          direction={{ default: 'column', md: 'row' }}
          justifyContent={{ md: 'spaceBetween' }}
          color="inherit"
          alignItems={shouldCenterIcon ? { md: 'center' } : undefined}
        >
          <Container>
            {alertTitle}
            {alertText}
          </Container>
          {alertActions}
        </Container>
      </Container>
    </AlertContext.Provider>
  );
};

Alert.displayName = 'Alert';

export default Alert;
